import React, { useEffect, useState } from 'react';

import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router';
import { Link, useSearchParams } from 'react-router-dom';
import { Alert, Col } from 'react-bootstrap';

import Layout from '../Layout';
import SpinnerBlock from '../../components/Common/Spinner/Spinner';
import SuccessMessage from '../../components/Checkout/SuccessMessage';

import routes from '../../constants/routes';
import es from '../../lang/es';
import PaymentLotList from '../../components/PaymentLots/PaymentLotList';
import { useDispatch, useSelector } from 'react-redux';

import { listPaymentLotsAction } from '../../actions/paymentLotsActions';
import queryParams from '../../constants/queryParams';
import apiMethods from '../../constants/apiMethods';
import api from '../../helpers/api';

const Checkout = () => {
    //History
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    //Actions
    const actions = [
        {
            title: es.ACTIONS.NEW,
            type: 'success',
            icon: faPlus,
            visible: true,
            handle: () => {
                navigate(routes.PAYMENT_CREATE)
            }
        },
        {
            title: es.CLOSE.toUpperCase(),
            type: 'danger',
            icon: faTimes,
            visible: true,
            handle: () => {
                navigate(routes.HOME)
            }
        }
    ];
    //Store
    const loading = useSelector( state => state.paymentLots.loading );
    const paymentLots = useSelector( state => state.paymentLots.paymentLots );
    //State local
    const [waiting, setWaiting] = useState(false)
    //Cargo datos al inicio
    useEffect(() => {
        init();
    }, []);
    //Manejo el control de pantalla
    const init = () => {
        //Verifico si es cancelar
        if(location.pathname === routes.PAYMENT_CHECKOUT_CANCEL){
            //Tomo params
            const lotId = searchParams.get(queryParams.lotId);
            const status = searchParams.get(queryParams.status);
            //Busco los parámetros
            if(lotId && status && status === queryParams.cancelStatus){
                //Cancelo el checkout
                checkoutCancel(lotId, status);
            }
        }else{
            //Cargo los lotes
            loadLots();
        }
    }
    //Manejo la carga de lotes
    const loadLots = () => {
        //Cargo los lotes
        dispatch( listPaymentLotsAction() );
    }
    //Manejo la cancelación de lotes
    const checkoutCancel = async (lotId, status) => {
        //Cargo espera
        setWaiting(true);
        //Ejecuto operación
        try{
            //Query
            await api.post(apiMethods.CHECKOUT_CANCEL, {
                lotId,
                status
            });
        }catch(error){
            //Tomo error
            const errorResponse = error.response;
            //Inicializo
            let errorData = {
                data: null,
                message: es.ERRORS.SERVER_CONN
            };
            //Verifico si hay error
            if(errorResponse){
                errorData = errorResponse.data;
            }
        }
        //Espero 1 segundo
        setTimeout(() => {
            //Redirecciono
            navigate(routes.PAYMENT_CHECKOUT);
            //Recargo lotes
            loadLots();
            //Quito espera
            setWaiting(false);
        }, 1000);
    }
    //Render
    return (
        <SpinnerBlock active={loading || waiting}>
            <Layout
                title={ es.APP_NAME }
                subtitle={ es.PAYMENTS.CHECKOUT }
                items={[
                    {
                        title: es.HOME,
                        link: routes.HOME
                    },
                    {
                        title: es.PAYMENTS.CHECKOUT,
                        active: true
                    }
                ]}
                actions={actions}
            >
                <SuccessMessage  />
                {
                    paymentLots ? (
                        paymentLots.length > 0 ? (
                            <>
                            <Col xs={12}>
                                <Alert variant="info">
                                A continuación se muestran los diferentes <strong>lotes disponibles para pagar</strong>. Por cada uno de esos debe seleccionar el método de pago a realizar: <strong>En sucursal</strong> u <strong>Online</strong>. En caso del primero se generará un comprobante en PDF con el que debe asistir a la sucursal del Banco Macro. Para <strong>Pago Online</strong> se redigirá al usuario a la plataforma correspondiente.
                                </Alert>
                            </Col>
                            <PaymentLotList
                                paymentLots={paymentLots}
                            />
                            </>
                        ) : (
                            <Col xs={12}>
                            <Alert variant="info">
                                No se encontraron pagos para finalizar. Si desea generar uno nuevo, haga click <Link to={routes.PAYMENT_CREATE}><strong>aquí</strong></Link>.
                            </Alert>
                            </Col>
                        )
                    ) : null
                }
            </Layout>
        </SpinnerBlock>
    );
};

export default Checkout;